import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Contract, ContractForm} from '../models/contract';


export const contractAddActionTypes = {
  ADD: type('[contract] Add'),
  ADD_SUCCESS: type('[contract] Add Success'),
  ADD_FAIL: type('[contract] Add Fail'),
  UPDATE_COMMENT: type('[contract Comment] update'),
  UPDATE_COMMENT_SUCCESS: type('[contract Comment] update Success'),
};

export class AddContractAction implements Action {
  readonly type = contractAddActionTypes.ADD;
  constructor(public payload?: ContractForm) {}
}

export class AddContractSuccessAction implements Action {
  readonly type = contractAddActionTypes.ADD_SUCCESS;
  constructor(public payload?: Contract) {}
}

export class AddContractFailAction implements Action {
  readonly type = contractAddActionTypes.ADD_FAIL;
  constructor(public payload?: string) {}
}


export class UpdateContractCommentAction implements Action {
  readonly type = contractAddActionTypes.UPDATE_COMMENT;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}
export class UpdateContractCommentSuccessAction implements Action {
  readonly type = contractAddActionTypes.UPDATE_COMMENT_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}
